module.exports = __webpack_public_path__ + "static/cabbage-0105551bcba80a62584d891e448ef8f8.svg";